import { defineMessages } from 'react-intl'

export default defineMessages({
  otherVehicleHeadline: {
    id: 'app.otherVehicle.headline',
    defaultMessage: 'Vehicle and driver info',
  },
  // Placeholder messages
  placeholderMake: {
    id: 'app.otherVehicle.placeholder.make',
    defaultMessage: 'Make',
  },
  placeholderModel: {
    id: 'app.otherVehicle.placeholder.model',
    defaultMessage: 'Model',
  },
  placeholderColor: {
    id: 'app.otherVehicle.placeholder.color',
    defaultMessage: 'Color',
  },
  placeholderYear: {
    id: 'app.otherVehicle.placeholder.year',
    defaultMessage: 'Year',
  },
  placeholderFirstName: {
    id: 'app.otherVehicle.placeholder.firstName',
    defaultMessage: 'First name',
  },
  placeholderLastName: {
    id: 'app.otherVehicle.placeholder.lastName',
    defaultMessage: 'Last name',
  },
  placeholderPolicy: {
    id: 'app.otherVehicle.placeholder.policy',
    defaultMessage: 'Policy #',
  },
  placeholderLicensePlate: {
    id: 'app.otherVehicle.placeholder.licensePlate',
    defaultMessage: 'License Plate #',
  },
  placeholderInsuranceCompany: {
    id: 'app.otherVehicle.placeholder.insuranceCompany',
    defaultMessage: 'Insurance Company',
  },
  placeholderDriverLicense: {
    id: 'app.otherVehicle.placeholder.driverLicense',
    defaultMessage: 'Driver License #',
  },
  placeholderPhone: {
    id: 'app.otherVehicle.placeholder.phone',
    defaultMessage: 'Phone #',
  },

  // Validation messages
  validationMakeRequired: {
    id: 'app.otherVehicle.validation.makeRequired',
    defaultMessage: 'Make is required!',
  },
  validationModelRequired: {
    id: 'app.otherVehicle.validation.modelRequired',
    defaultMessage: 'Model is required!',
  },
  validationColorRequired: {
    id: 'app.otherVehicle.validation.colorRequired',
    defaultMessage: 'Color is required!',
  },
  validationYearRequired: {
    id: 'app.otherVehicle.validation.yearRequired',
    defaultMessage: 'Year is required!',
  },
  validationFirstNameRequired: {
    id: 'app.otherVehicle.validation.firstNameRequired',
    defaultMessage: 'First name is required!',
  },
  validationLastNameRequired: {
    id: 'app.otherVehicle.validation.lastNameRequired',
    defaultMessage: 'Last name is required!',
  },
  validationPolicyRequired: {
    id: 'app.otherVehicle.validation.policyRequired',
    defaultMessage: 'Policy is required!',
  },
  validationLicensePlateRequired: {
    id: 'app.otherVehicle.validation.licensePlateRequired',
    defaultMessage: 'License plate is required!',
  },
  validationInsuranceCompanyRequired: {
    id: 'app.otherVehicle.validation.insuranceCompanyRequired',
    defaultMessage: 'Insurance company is required!',
  },
  validationDriverLicenseRequired: {
    id: 'app.otherVehicle.validation.driverLicenseRequired',
    defaultMessage: 'Driver license is required!',
  },
  validationPhoneRequired: {
    id: 'app.otherVehicle.validation.phoneRequired',
    defaultMessage: 'Phone is required!',
  },
  claimsOtherOwnerOfVehicleSwitch: {
    id: 'app.otherVehicle.ownerOfVehicleSwitch',
    defaultMessage: 'Is this the owner of the vehicle?',
  },
})
